<template>
    <div
        style="width: 100%;height: 100vh;background-color: #fff;display: flex;justify-content: center;align-items: center;">

        <div>
            <img @click="toWXBuyCard()" style="width: 50%;margin: 0 auto;" src="../../assets/tocoupon_qrcode.jpg" />
            <div style="text-align: center;font-size: 1rem;margin-top: 2rem;padding-bottom: 5rem;">长按识别二维码打开小程序</div>
        </div>

    </div>
</template>
  
<script>
export default {
    data() {
        return {


        }
    },
    created() {
        this.toWXBuyCard()
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        toWXBuyCard() {
            // toolgetUrlScheme
            var $this = this
            // this.$loading('加载中');
            let param = {
               
                path:'/pages/mycoupon/mycoupon'
              
            }
            var qs = require('qs');
            let url = this.api.userApi.toolgetUrlScheme
            // console.log('flGetUserInfoByOpenid')
            this.axios.post(url, qs.stringify(param),)
                .then((result) => {
                    console.log(result)
                    if (result.code == 200) {
                        location.href = result.data.openlink
                    } else {
                        // $this.$loading.close()
                    }
                }).catch((error) => {
                    console.warn(error)
                    // $this.$loading.close()
                    // $this.$toast('error');
                })
            // window.location.href='weixin://dl/business/?t=wYfWQ1ZbZnn'
            // this.$dialog.alert({
            //   title: '提示',
            //   message: '等小程序上线后才会有链接跳转',
            // }).then(() => {
            //   // on close
            // });
        }
    },
    destroyed() {

    }
}
</script>
  
<style lang="less" scoped="scoped">
@vm_base: 1/750*100vw;

body {
    background-color: #fff;
}
</style>
  


// WEBPACK FOOTER //
// src/components/aa_toWx/tomycoupon.vue